export const PlanBase = {
    name: "",
    visible: true,
    modules: [
        {
            label: "Importação de dados",
            name: "ImportData",
            contracted: false,
            sources: []
        },
        {
            label: "Edição de dados",
            name: "EditData",
            contracted: false,
            sources: []
        },
        {
            label: "Cenário",
            name: "Scenario",
            contracted: false,
            sources: []
        },
        {
            label: "Dashboards",
            name: "Dashboards",
            contracted: false,
            sources: []
        },
        {
            label: "Plano de contas",
            name: "AccountsPlan",
            contracted: false,
            sources: []
        },
        {
            label: "Auditoria da cateira",
            name: "MonitoringPortfolio",
            contracted: false,
            sources: []
        },
        {
            label: "Auditoria",
            name: "Monitoring",
            contracted: false,
            sources: []
        },
        {
            label: "Demonstrações",
            name: "Demonstrations",
            contracted: false,
            sources: []
        },
        {
            label: "Comparações",
            name: "Comparations",
            contracted: false,
            sources: []
        },
        {
            label: "Dash",
            name: "Reports",
            contracted: false,
            sources: []
        },
        {
            label: "Customização Geral",
            name: "GeneralCustomization",
            contracted: false,
            sources: []
        },
        {
            label: "Customização de dashboard",
            name: "DashboardCustomization",
            contracted: false,
            sources: []
        },
        {
            label: "Customização de indicador",
            name: "IndicatorCustomization",
            contracted: false,
            sources: []
        },
        {
            label: "Customização de gráfico",
            name: "ChartCustomization",
            contracted: false,
            sources: []
        },
        {
            label: "Importação em lote",
            name: "BatchImport",
            contracted: false,
            sources: []
        },
        {
            label: "Importação PGDAs",
            name: "PGDAS",
            contracted: false,
            sources: []
        },
        {
            label: "Importação eSocial",
            name: "eSocial",
            contracted: false,
            sources: []
        },
        {
            label: "Automações",
            name: "Automations",
            contracted: false,
            sources: []
        }
    ],
    features: [
        {
            label: "Gestão do Usuário",
            name: "UsersManagement",
            contracted: false
        },
        { label: "Suporte", name: "Support", contracted: false },
        { label: "Nucontent", name: "Nucontent", contracted: false },
        { label: "Prospect", name: "Prospect", contracted: false },
        { label: "NPS", name: "NPS", contracted: false },
        { label: "Logo empresas", name: "Logo", contracted: false },
        { label: "Paleta de Cores", name: "Themes", contracted: false },
        { label: "Score", name: "Score", contracted: false },
        { label: "Análise em Grupo", name: "Groups", contracted: false },
        {
            label: "Chat da IA do Contador",
            name: "IAContador",
            contracted: false
        },
        {
            label: "Atalhos da IA do Contador",
            name: "IAShortcutsAccounting",
            contracted: false
        },
        {
            label: "Chat da IA do Empresário",
            name: "IAEmployee",
            contracted: false
        },
        {
            label: "Parametrização Automática",
            name: "AutomaticParameterization",
            contracted: false
        },
        {
            label: "Análise Plus",
            name: "AnalysisPlus",
            contracted: false
        },
        {
            label: "Domínio Contábil",
            name: "DominioAccounting",
            contracted: false
        },
        {
            label: "Contabit",
            name: "Contabit",
            contracted: false
        },
        { label: "Conta Azul", name: "ContaAzul", contracted: false },
        { label: "Nibo", name: "Nibo", contracted: false },
        { label: "Fortes", name: "Fortes", contracted: false },
        { label: "Omie", name: "Omie", contracted: false },
        { label: "PGDAS", name: "PGDAS", contracted: false },
        { label: "eSocial", name: "eSocial", contracted: false }
    ]
};

export const PlanMockNew = {
    name: "",
    hidden: false,
    modules: [],
    features: []
};

export const PlanFormBase = {
    name: "",
    features: [
        { name: "Gestão do Usuário", value: "UsersManagement" },
        { name: "Nucontent", value: "Nucontent" },
        { name: "Suporte", value: "Support" },
        { name: "Prospect", value: "Prospect" },
        { name: "NPS", value: "NPS" },
        { name: "Logo empresas", value: "Logo" },
        { name: "Paleta de Cores", value: "Themes" },
        { name: "Score", value: "Score" },
        { name: "Análise em Grupo", value: "Groups" },
        { name: "Chat da IA do Contador", value: "IAContador" },
        { name: "Atalhos da IA do Contador", value: "IAShortcutsAccounting" },
        { name: "Chat da IA do Empresário", value: "IAEmployee" },
        {
            name: "Parametrização Automática",
            value: "AutomaticParameterization"
        },
        {
            name: "Análise Plus",
            value: "AnalysisPlus"
        }
    ],
    modules: [
        {
            source: "accounting",
            sourceName: "Contábil",
            modules: [
                { name: "Importação de dados", value: "ImportData" },
                { name: "Cenário", value: "Scenario" },
                { name: "Dashboards", value: "Dashboards" },
                { name: "Plano de contas", value: "AccountsPlan" },
                {
                    name: "Monitoramento da carteira",
                    value: "MonitoringPortfolio"
                },
                { name: "Monitoramento", value: "Monitoring" },
                { name: "Demonstrações", value: "Demonstrations" },
                { name: "Comparações", value: "Comparations" },
                { name: "Dash", value: "Reports" },
                { name: "Customização Geral", value: "GeneralCustomization" },
                {
                    name: "Customização de dashboard",
                    value: "DashboardCustomization"
                },
                {
                    name: "Customização de indicador",
                    value: "IndicatorCustomization"
                },
                {
                    name: "Customização de gráfico",
                    value: "ChartCustomization"
                },
                {
                    name: "Automações",
                    value: "Automations"
                }
            ]
        },
        {
            source: "fin",
            sourceName: "Financeiro",
            modules: [
                { name: "Importação de dados", value: "ImportData" },
                { name: "Edição de dados", value: "EditData" },
                { name: "Cenário", value: "Scenario" },
                { name: "Dashboards", value: "Dashboards" },
                {
                    name: "Monitoramento da carteira",
                    value: "MonitoringPortfolio"
                },
                { name: "Monitoramento", value: "Monitoring" },
                { name: "Demonstrações", value: "Demonstrations" },
                { name: "Importação em lote", value: "BatchImport" },
                { name: "Comparações", value: "Comparations" },
                { name: "Dash", value: "Reports" },
                {
                    name: "Customização de dashboard",
                    value: "DashboardCustomization"
                },
                {
                    name: "Customização de indicador",
                    value: "IndicatorCustomization"
                },
                {
                    name: "Customização de gráfico",
                    value: "ChartCustomization"
                },
                {
                    name: "Automações",
                    value: "Automations"
                }
            ]
        },
        {
            source: "tax",
            sourceName: "Fiscal",
            modules: [
                { name: "Importação de dados", value: "ImportData" },
                { name: "Edição de dados", value: "EditData" },
                { name: "Cenário", value: "Scenario" },
                { name: "Dashboards", value: "Dashboards" },
                {
                    name: "Monitoramento da carteira",
                    value: "MonitoringPortfolio"
                },
                { name: "Monitoramento", value: "Monitoring" },
                { name: "Demonstrações", value: "Demonstrations" },
                { name: "Importação em lote", value: "BatchImport" },
                { name: "Importação PGDAs", value: "PGDAS" },
                { name: "Comparações", value: "Comparations" },
                { name: "Dash", value: "Reports" },
                {
                    name: "Customização de dashboard",
                    value: "DashboardCustomization"
                },
                {
                    name: "Customização de indicador",
                    value: "IndicatorCustomization"
                },
                {
                    name: "Customização de gráfico",
                    value: "ChartCustomization"
                },
                {
                    name: "Automações",
                    value: "Automations"
                }
            ]
        },
        {
            source: "personnel",
            sourceName: "Pessoal",
            modules: [
                { name: "Importação de dados", value: "ImportData" },
                { name: "Edição de dados", value: "EditData" },
                { name: "Cenário", value: "Scenario" },
                { name: "Dashboards", value: "Dashboards" },
                {
                    name: "Monitoramento da carteira",
                    value: "MonitoringPortfolio"
                },
                { name: "Monitoramento", value: "Monitoring" },
                { name: "Demonstrações", value: "Demonstrations" },
                { name: "Importação em lote", value: "BatchImport" },
                { name: "Importação eSocial", value: "eSocial" },
                { name: "Comparações", value: "Comparations" },
                { name: "Dash", value: "Reports" },
                {
                    name: "Customização de dashboard",
                    value: "DashboardCustomization"
                },
                {
                    name: "Customização de indicador",
                    value: "IndicatorCustomization"
                },
                {
                    name: "Customização de gráfico",
                    value: "ChartCustomization"
                },
                {
                    name: "Automações",
                    value: "Automations"
                }
            ]
        }
    ],
    integrations: [
        { name: "Domínio Contábil", value: "DominioAccounting" },
        { name: "Contabit", value: "Contabit" },
        { name: "Conta Azul", value: "ContaAzul" },
        { name: "Nibo", value: "Nibo" },
        { name: "Fortes", value: "Fortes" },
        { name: "Omie", value: "Omie" },
        { name: "PGDAS", value: "PGDAS" },
        { name: "eSocial", value: "eSocial" }
    ]
};
